import { render, staticRenderFns } from "./EmailWorkflowForm.vue?vue&type=template&id=c53d422e&scoped=true"
import script from "./EmailWorkflowForm.vue?vue&type=script&lang=js"
export * from "./EmailWorkflowForm.vue?vue&type=script&lang=js"
import style0 from "./EmailWorkflowForm.vue?vue&type=style&index=0&id=c53d422e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53d422e",
  null
  
)

export default component.exports